/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';
 
export interface ModifyIconProps extends IconProps {
  disable?: boolean,
  opacity?: number
}

/*
 * Defines the Design Language System (DLS) Modify Icon component.
 */
export const ModifyIcon = ({color, size}: ModifyIconProps) => {
  const {iconSize} = useIconDLS({color, size});
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_5501_105479)">
        <g clipPath="url(#clip1_5501_105479)">
          <path d="M7.22461 16.3817C7.22963 16.5151 7.28465 16.6417 7.37863 16.7361C7.47262 16.8305 7.59862 16.8857 7.73144 16.8908L10.174 16.7681C10.2982 16.7619 10.4156 16.7096 10.5033 16.6215L20.5036 6.57691L17.4626 3.52246L7.4639 13.5654C7.37522 13.6545 7.32334 13.7737 7.31859 13.8993L7.22461 16.3817Z" stroke="#828282" strokeWidth="1.5" strokeMiterlimit="10"/>
          <path d="M19.3574 0.540039L23.4526 4.65336" stroke="#828282" strokeWidth="1.5" strokeMiterlimit="10"/>
          <path d="M18.2723 12.696V21.736C18.2723 22.0122 18.0485 22.236 17.7723 22.236H2.25977C1.98362 22.236 1.75977 22.0122 1.75977 21.736V6.15039C1.75977 5.87425 1.98362 5.65039 2.25977 5.65039H11.5416" stroke="#828282" strokeWidth="1.5" strokeMiterlimit="10"/>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_5501_105479">
          <rect width="24" height="24" fill="white"/>
        </clipPath>
        <clipPath id="clip1_5501_105479">
          <rect width="23" height="23" fill="white" transform="translate(1)"/>
        </clipPath>
      </defs>
    </svg>
  );
};
